import i18n from '@/locale'
export const platformOptions = [
  { label: i18n.t('美团'), value: 'MT', cover: require("@/assets/takeaway/mt.png") },
  { label: i18n.t('饿了么'), value: 'ELM', cover: require("@/assets/takeaway/ele.png") },
  { label: i18n.t('京东'), value: 'JD', cover: require("@/assets/takeaway/jd.png") },
]

/** 订单等场景使用：在外卖三平台基础上增加会员小程序 */
export const nPlatformOptions = [
  ...platformOptions,
  {
    label: i18n.t('会员小程序'),
    value: 'XCX',
    cover: require('@/assets/takeaway/member.png'),
  },
]

export const platformStrMap = platformOptions.reduce((t, c) => Object.assign(t, { [c.value]: c.label }), {})
